/**
 * 自定义表单校验
 */

/**
 * 自定义校验：手机号码
 * @param rule
 * @param value
 * @param callback
 */
export const validateMobile = (rule, value, callback) => {
    if (!value) {
        callback();
        return;
    }
    const reg = /^1[0-9]{10}$/;
    reg.test(value) ? callback() : callback(new Error(`请输入正确格式的${rule.label}`));
};

/**
 * 自定义校验：邮箱
 * @param rule
 * @param value
 * @param callback
 */
export const validateEmail = (rule, value, callback) => {
    if (!value) {
        callback();
        return;
    }
    const reg = /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/;
    reg.test(value) ? callback() : callback(new Error(`请输入正确格式的${rule.label}`));
};

/**
 * 自定义校验：电话号码，座机
 * @param rule
 * @param value
 * @param callback
 */
export const validatePhone = (rule, value, callback) => {
    if (!value) {
        callback();
        return;
    }
    const reg = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
    reg.test(value) ? callback() : callback(new Error(`请输入正确格式的${rule.label}`));
};

/**
 * 自定义校验：网站地址
 * @param rule
 * @param value
 * @param callback
 */
export const validateURL = (rule, value, callback) => {
    if (!value) {
        callback();
        return;
    }
    const reg = /^http[s]?:\/\/.*/;
    reg.test(value) ? callback() : callback(new Error(`请输入正确格式的${rule.label}`));
};

/**
 * 自定义校验：邮政编码
 * @param rule
 * @param value
 * @param callback
 */
export const validatePostCode = (rule, value, callback) => {
    if (!value) {
        callback();
        return;
    }
    const reg = /^[0-9]{6}$/;
    reg.test(value) ? callback() : callback(new Error(`请输入正确格式的${rule.label}`));
};

/**
 * 自定义校验：身份证
 * @param rule
 * @param value
 * @param callback
 * @returns {*}
 */
export const validateCardId = (rule, value, callback) => {
    if (!value) {
        callback();
        return;
    }
    // 前两位地区码检验
    const aCity = [
        '11',
        '12',
        '13',
        '',
        '14',
        '15',
        '21',
        '22',
        '23',
        '31',
        '32',
        '33',
        '34',
        '35',
        '36',
        '37',
        '41',
        '42',
        '43',
        '44',
        '45',
        '46',
        '50',
        '51',
        '52',
        '53',
        '54',
        '61',
        '62',
        '63',
        '64',
        '65',
        '71',
        '81',
        '82',
        '91',
    ];
    const areaFlag = aCity.indexOf(value.substring(0, 2)) > -1;

    // 身份证顺序检验
    const reg = /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9X]/;
    const checkFlag = reg.test(value);

    // 检验位码检验(计算公式：∑(ai×Wi)(mod 11))
    const factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ]; // 加权因子
    const parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ]; // 检验位值
    let sum = 0;
    let ai = 0;
    let wi = 0;
    for (let i = 0; i < 17; i++) {
        ai = value[i];
        wi = factor[i];
        sum += ai * wi;
    }
    const lastFlag = parity[sum % 11] == value.substr(17, 1);

    return areaFlag && checkFlag && lastFlag ? callback() : callback(new Error(`请输入正确格式的${rule.label}`));
};

export const ruleOptions = [
    { value: 'validateCardId', label: '身份证' },
    { value: 'validateMobile', label: '手机号码' },
    { value: 'validateEmail', label: '电子邮箱' },
    { value: 'validatePostCode', label: '邮政编码' },
    { value: 'validatePhone', label: '电话号码(座机)' },
    { value: 'validateURL', label: '网址' },
];

export default {
    validateMobile,
    validateEmail,
    validatePhone,
    validateURL,
    validateCardId,
    validatePostCode,
};
